/**
 * Created by vsuthar on 9/14/21
 * File: SummaryLicenseEmpty
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Body, Bold, Card, CardBody, NoIntegrationSVG, Title } from '@panwds/react-ui'
import StringTemplate from '../../../common/utils/StringTemplate'
import {
  ACTIVATE_SDWAN,
  BUTTON_ADD_LICENSE_PRODUCT,
  LABEL_SUMMARY_NO_LICENSE_FOR_NODE
} from '../../constants/LabelConstants'
import './SummaryLicenseEmpty.scss'
import { getVarValue } from '../../../common/utils/Sparky'
import { FF_DISABLE_LICENSE_TABLE_EDIT } from '../../../common/utils/FeatureFlags'


const SummaryLicenseEmpty = ({ selectedTreeNode, onAddSubTenant, onAddLicenses, isCgxPresent, ...rest }) => {
  const disableEditIcon = getVarValue(FF_DISABLE_LICENSE_TABLE_EDIT, false)
  // return (<div style={{ padding: '19px 19px 19px 40px' }} className={'tw-border-solid tw-flex tw-flex-row tw-items-center tw-gap-3 tw-border tw-border-gray-200 tw-rounded'}>
  //   <NoIntegrationSVG style={{ height: 60, width: 60 }}/>
  //   <div className={'tw-flex tw-flex-col'}>
  //     <Body>{StringTemplate(LABEL_SUMMARY_NO_LICENSE_FOR_NODE, [selectedTreeNode?.display_name])}</Body>
  //     <Body>{StringTemplate(LABEL_SUMMARY_NO_LICENSE_SUB_TITLE, [selectedTreeNode?.display_name])}</Body>
  //     <div className={'tw-flex tw-flex-row'}>
  //       {rest.showSubscriptions && <Button addClassName='tw-mr-2' onClick={onAddLicenses} appearance={'primary'}>{BUTTON_ADD_LICENSE_PRODUCT}</Button>}
  //       <Button disabled={selectedTreeNode?.id === ROOT_NODE_ID} onClick={onAddSubTenant} appearance={'primary'}>{BUTTON_ADD_SUB_TENANT}</Button>
  //     </div>
  //   </div>
  // </div>
  //)

  return <Card addClassName='tw-w-full' style={{ height: 90 }}>
    <CardBody>
      <div className='tw-flex tw-flex-row tw-w-1/2 tw-relative'>
        <div style={{ height: 64.2, width: 43.76 }}>
          <NoIntegrationSVG />
        </div>
        <div className='tw-pl-6 tw-pt-3 tw-mr-8'>
          <Title level={2} size='xxs' addClassName='tw-text-gray-900'>
            {StringTemplate(LABEL_SUMMARY_NO_LICENSE_FOR_NODE, [selectedTreeNode?.display_name])}
          </Title>
        </div>
        <div className='tw-flex tw-flex-col tw-pt-4 tw-items-center'>
          {rest.showSubscriptions && !disableEditIcon && <Body size='md' addClassName='tw-justify-right tw-text-blue-600 tw-pl-8'><Bold><a onClick={onAddLicenses}>{BUTTON_ADD_LICENSE_PRODUCT}</a></Bold></Body>}
          {isCgxPresent && <div className="summary-license-box tw-text-center tw-absolute tw-p-2" style={{ bottom: -20 }}>
            <Body size='sm' addClassName='tw-text-gray-600 tw-ml-6'>{ACTIVATE_SDWAN}</Body>
            <div className="summary-license-arrow summary-license-arrow-top"/>
          </div>}
        </div>
      </div>
    </CardBody>
  </Card>
}

SummaryLicenseEmpty.propTypes = {}
export default SummaryLicenseEmpty

